"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('calendarAppearanceOption', {
    weekStartDay: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/store/store.js
// module id = 3094
// module chunks = 2